/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Page_Compare_DescriptionInputs */

const en_cad_page_compare_description = /** @type {(inputs: Cad_Page_Compare_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fair comparison of ArtCraft CADCraft and AutoCAD: price, license, platforms, DWG and DXF support, AI agent control, features and maturity.`)
};

/**
* | output |
* | --- |
* | "A fair comparison of ArtCraft CADCraft and AutoCAD: price, license, platforms, DWG and DXF support, AI agent control, features and maturity." |
*
* @param {Cad_Page_Compare_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_page_compare_description = /** @type {((inputs?: Cad_Page_Compare_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Page_Compare_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_page_compare_description(inputs)
});
export { cad_page_compare_description as "cad.page.compare.description" }